import Vue from 'vue'
import '@/lib/api'

import '@/assets/css/tailwind.css'
import './app.css'

import Login from './Login.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(Login)
}).$mount('#app')
